import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Header from "../components/header"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Section from "../components/section"
import Hero from "../components/hero"
import Service from "../components/service"
import Card from "../components/card"

const resolveFeatureFlag = (flagValue, enabledByMode) => {
  if (flagValue === "true") return true
  if (flagValue === "false") return false
  return enabledByMode
}

function IndexPage() {
  const siteMode =
    process.env.GATSBY_SITE_MODE || process.env.GATSBY_siteType || "booking"
  const isServicesEnabled = resolveFeatureFlag(
    process.env.GATSBY_ENABLE_SERVICES,
    siteMode !== "cart"
  )

  const data = useStaticQuery(
    graphql`
      query IndexPageContent {
        allContentfulProducto {
          edges {
            node {
              codigo
              nombre
              precio
              descuento
              descripcion {
                raw
              }
              marca
              categoria
              imagenes {
                file {
                  url
                }
              }
            }
          }
        }
        allContentfulServicio {
          edges {
            node {
              codigo
              nombre
              precio
              summary {
                raw
              }
              imagenes {
                file {
                  url
                }
              }
              bgImage {
                file {
                  url
                }
              }
            }
          }
        }
        allContentfulSeccion(sort: { fields: contentfulid, order: ASC }) {
          edges {
            node {
              contentfulid
              title {
                title
              }
              bgimage {
                file {
                  url
                }
              }
              contenido {
                raw
              }
            }
          }
        }
        contentfulInfoGeneral {
          titulo
          subtitulo
          slogan {
            slogan
          }
          imagenIntro {
            file {
              url
            }
          }
          imagenCarrusel {
            id
            file {
              url
            }
          }
        }
      }
    `
  )

  const hasProducts = data.allContentfulProducto.edges.length > 0
  const hasServices =
    isServicesEnabled && data.allContentfulServicio.edges.length > 0
  const hasSections = data.allContentfulSeccion.edges.length > 0

  return (
    <Layout>
      <Seo path="/" />
      <Header site="index" />
      <Hero data={data.contentfulInfoGeneral} />

      {hasProducts && <Card data={data} />}

      {hasServices && (
        <Service data={data.allContentfulServicio} animation={true} />
      )}

      {hasSections &&
        data.allContentfulSeccion.edges.map((edge) => (
          <Section key={edge.node.contentfulid} data={edge.node} />
        ))}
    </Layout>
  )
}

export default IndexPage
